module.exports = __webpack_public_path__ + "img/kukuru_HEP_FIVE_tc.a1b20200.jpg";